export enum CalibrationLevel {
	Elite = 'elite',
	Good = 'good',
	Developing = 'developing',
	Insufficient = 'insufficient',
}
